import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import "./App.css";
import { FaPersonChalkboard } from "react-icons/fa6";
import { IoMdHome } from "react-icons/io";
import { HiShoppingCart } from "react-icons/hi";
import { FaBoxOpen } from "react-icons/fa6";
import { RiAdvertisementFill } from "react-icons/ri";
import { MdBusinessCenter } from "react-icons/md";
import { AiOutlineTransaction } from "react-icons/ai";
import { MdReport } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineLogout } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import "react-toastify/dist/ReactToastify.css";
import { Badge, message } from "antd";
import { DiRequirejs } from "react-icons/di";
import { MdAdminPanelSettings } from "react-icons/md";
import axios from "axios";
import { API_URL } from "./Api/Config";

function BrandExample() {
  const location = useLocation();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  const handleLogout = () => {
    navigate("/");
    localStorage.removeItem("dashtoken");
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    const socket = io("https://api.meatmarket.live/");
    socket.on("connect", () => {
      console.log("Connected to server");
    });

    socket.on("newOrder", (notification) => {
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
    });

    // Cleanup the socket connection when the component unmounts
    return () => {
      socket.disconnect();
    };
  }, []);

  const [role, setRole] = useState("");

  const [data, setData] = useState([]);

  const getSubAdmin = async () => {
    try {
      const token = localStorage.getItem("dashtoken");
      if (!token) {
        message.error("Login required!");
        localStorage.clear();
        return;
      }
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData(res.data.user.accessTabs || []);
      setRole("subadmin");
    } catch (error) {
      console.log(error);
    }
  };

  const allNavItems = [
    { path: "/products", label: "Products", icon: <HiShoppingCart /> },
    { path: "/orders", label: "Orders", icon: <FaBoxOpen />, isOrder: true },
    { path: "/banners", label: "Banners", icon: <RiAdvertisementFill /> },
    {
      path: "/business-with-us",
      label: "Business with us",
      icon: <MdBusinessCenter />,
    },
    {
      path: "/transaction",
      label: "Transaction",
      icon: <AiOutlineTransaction />,
    },
    { path: "/franchies", label: "Franchies", icon: <MdManageAccounts /> },
    { path: "/requirement", label: "Requirement", icon: <DiRequirejs /> },
    { path: "/customer", label: "Customer", icon: <FaPersonChalkboard /> },
    { path: "/reports", label: "Reports", icon: <MdReport /> },
    { path: "/sub-admin", label: "Sub Admin", icon: <MdAdminPanelSettings /> },
  ];

  useEffect(() => {
    let dtoken = localStorage.getItem("userRole");
    if (dtoken === "subadmin") {
      getSubAdmin();
    }
  }, []);

  return (
    <>
      {/* NAVBAR */}
      <Navbar className="bg-body-tertiary side-nav">
        <div className="bar">
          <div>
            <img className="logo" src="/assests/logo-img.png" alt="logo" />
          </div>
          <div className="b-bar-contain">
            <Link to="/" activeStyle style={{ textDecoration: "none" }}>
              <div
                className="b-bar-content"
                id={location.pathname === "/" ? "active" : ""}
              >
                <div className="b-bar-font">
                  <IoMdHome />
                </div>

                <div className="b-bar-font-content">Home</div>
              </div>
            </Link>

            {allNavItems.map((item) => {
              const isActive = location.pathname === item.path;
              const shouldRender =
                role !== "subadmin" || data.includes(item.path);

              if (!shouldRender) return null;

              return (
                <Link
                  to={item.path}
                  style={{ textDecoration: "none" }}
                  key={item.path}
                >
                  <div
                    className="b-bar-content"
                    id={isActive ? "active" : ""}
                    onClick={
                      item.isOrder ? () => setNotifications([]) : undefined
                    }
                  >
                    <div className="b-bar-font">{item.icon}</div>
                    {item.isOrder ? (
                      <Badge count={notifications.length}>
                        <div className="jk" style={{ color: isActive ? "#000" : "#fff" }}>
                          {item.label}
                        </div>
                      </Badge>
                    ) : (
                      <div className="b-bar-font-content">{item.label}</div>
                    )}
                  </div>
                </Link>
              );
            })}

            <a to="/" activeStyle style={{ textDecoration: "none" }}>
              <div className="b-bar-content">
                <div className="b-bar-font">
                  <MdOutlineLogout onClick={handleLogout} />
                </div>
                <div
                  className="b-bar-font-content"
                  style={{ cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  Logout
                </div>
              </div>
            </a>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default BrandExample;
